import DOMPurify from 'dompurify'
import { marked } from 'marked'
import TurndownService from 'turndown'

marked.setOptions({ breaks: true })

const htmlTagRegex = /<\/?[a-z][\s\S]*>/i
const turndownService = new TurndownService({
  headingStyle: 'atx',
  bulletListMarker: '-',
  codeBlockStyle: 'fenced',
})

export const isProbablyHtml = (value: string): boolean => {
  return htmlTagRegex.test(value)
}

export const markdownToHtml = (value: string): string => {
  if (!value) return ''
  if (isProbablyHtml(value)) {
    return DOMPurify.sanitize(value, { USE_PROFILES: { html: true } })
  }
  // marked.parse() returns string synchronously in v12
  const parsed = marked.parse(value) as string
  return DOMPurify.sanitize(parsed, { USE_PROFILES: { html: true } })
}

export const htmlToMarkdown = (value: string): string => {
  if (!value) return ''
  if (!isProbablyHtml(value)) return value
  return turndownService.turndown(value)
}
